import React from 'react';
import { StaticPage, TopbarContainer } from '..';
import {
  LayoutSingleColumn,
  LayoutWrapperTopbar,
  LayoutWrapperMain,
  LayoutWrapperFooter,
  Footer,
  NamedLink,
} from '../../components';
import { FormattedMessage } from '../../util/reactIntl';

import css from './ExplainElectricBrakesPage.module.css';
import image from '../../assets/trailer-with-sticker.avif';

const ExplainElectricBrakesPage = () => {
  return (
    <StaticPage
      title="Electric brake controllers explained"
      schema={{
        '@context': 'http://schema.org',
        '@type': 'ExplainElectricBrakesPage',
        description: 'Electric trailer brakes explained',
        name: 'What are electric trailer brakes?',
      }}
    >
      <LayoutSingleColumn>
        <LayoutWrapperTopbar>
          <TopbarContainer />
        </LayoutWrapperTopbar>

        <LayoutWrapperMain className={css.staticPageWrapper}>
          <div className={css.contentWrapper}>
            <div className={css.imageContainer}>
              <img src={image} alt="trailer" className={css.croppedImage} />
            </div>
            <div className={css.contentMain}>
              <h1 className={css.helpTitle}>Electric brake controller: what is that?</h1>
              <p>
                An electric brake controller for a trailer is a device installed in a vehicle that
                helps control the brakes on a trailer it's towing. When you hit the brakes in your
                vehicle, the controller sends signals to the brakes on the trailer, helping them to
                slow down or stop along with your vehicle. This ensures smoother and safer braking,
                especially when towing heavy loads.
              </p>
              <div>
                <h2>Do all vehicles have electric brake controllers?</h2>
                <p>
                  No, not all vehicles come with electric brake controllers installed. Electric
                  brake controllers are typically found in vehicles designed for towing trailers,
                  such as trucks, SUVs, and some larger cars. You will need to check that your car
                  has one.
                </p>
                <h2>
                  If my vehicle does not have an electric brake controller, can I hire a trailer
                  from Local Trailer Hire that requires electric brakes?
                </h2>
                <p>
                  No, you shouldn't tow a trailer that requires an electric brake controller if your
                  vehicle doesn't have one installed. Trailers that need electric brake controllers
                  usually do so because they're larger or heavier, and having proper braking control
                  is crucial for safety. Without an electric brake controller, your vehicle may
                  struggle to brake safely, especially in emergency situations or when towing
                  downhill. It's best to have an electric brake controller installed on your vehicle
                  before towing a trailer that requires one. This ensures that you have the
                  necessary braking control and helps maintain safety for you and others on the
                  road.
                </p>
                <h2>Can I use a portable electric brake controller?</h2>
                <p>
                  You can use a portable electric brake controller if your vehicle doesn't have one
                  installed. Portable brake controllers are designed to be easily installed and
                  removed, typically by plugging into the vehicle's electrical system and connecting
                  to the trailer's brakes. Some Local Trailer Hire trailer owners provide a portable
                  electric brake controller. Be sure to check the features of the trailer listing to
                  see if a portable electric brake controller is available.
                </p>
              </div>
            </div>
            <NamedLink name="HelpPage" className={css.link}>
              <h3 className={css.heading}>
                {'<'} <FormattedMessage id="Footer.toHelpPage" />
              </h3>
            </NamedLink>
          </div>
        </LayoutWrapperMain>
        <LayoutWrapperFooter>
          <Footer />
        </LayoutWrapperFooter>
      </LayoutSingleColumn>
    </StaticPage>
  );
};

export default ExplainElectricBrakesPage;
